// extracted by mini-css-extract-plugin
export default {"textList":"GateLivestreamPlusListItem_textList__ctVDr","checkmark":"GateLivestreamPlusListItem_checkmark__JAyMG","featureText":"GateLivestreamPlusListItem_featureText__chDlB"};